/**
 * Utility functions for working with domains and URLs
 */

/**
 * Get the current application domain including protocol
 * @returns The current domain (e.g., http://localhost:3000 or https://portal.veripay.com)
 */
export function getCurrentDomain(): string {
  // In browser environment
  if (typeof window !== 'undefined') {
    const { protocol, hostname, port } = window.location;
    return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  }
  
  // Fallback for non-browser environments
  return '';
}